// Local draft of in-progress plan picks, per subscription.
//
// Plan items only reach Recharge when the box is FULL (the Save button doesn't
// exist before that), so leaving the page mid-fill used to silently discard
// progress — the "my box was empty when I came back" complaint. BoxBuilder
// writes the member's local plan picks here on every edit; the box-selection
// store merges them back during hydration, but only while the server bundle
// still matches the state they were drafted against (`baseHash`) — a save from
// any device changes the hash and invalidates the draft.

const draftKey = (subscriptionId) => `wg_box_draft_${subscriptionId}`;

// Order-independent fingerprint of a bundle's items ("id:qty|id:qty|…").
export const hashBundleItems = (items = []) => items
  .map((i) => `${i.external_product_id || i.product_id || i.id}:${i.quantity || 0}`)
  .sort()
  .join('|');

// The items a draft is measured against: fallback bundles hydrate as an empty
// plan (see boxSelectionService.initialize), so they hash as empty too.
export const bundleItemsForHash = (subscription) => {
  const bundle = subscription?.include?.bundle_selections;
  if (!bundle || bundle.is_fallback || !Array.isArray(bundle.items)) return [];
  return bundle.items;
};

export const readBoxDraft = (subscriptionId) => {
  try {
    const raw = window.localStorage.getItem(draftKey(subscriptionId));
    const draft = raw ? JSON.parse(raw) : null;
    return draft && Array.isArray(draft.items) ? draft : null;
  } catch {
    return null;
  }
};

export const writeBoxDraft = (subscriptionId, draft) => {
  try {
    window.localStorage.setItem(draftKey(subscriptionId), JSON.stringify(draft));
  } catch { /* storage unavailable (private mode) — drafts just don't persist */ }
};

export const clearBoxDraft = (subscriptionId) => {
  try {
    window.localStorage.removeItem(draftKey(subscriptionId));
  } catch { /* ignore */ }
};
